
<template>
  <div class="">

    <div v-if="loading" class="text-gray-500">Chargement...</div>
    <div v-else-if="convsInfos.length === 0" class="text-gray-500">Aucune conversation trouvée.</div>

    <ul v-else class="space-y-3">
      <li
        v-for="conv in convsInfos"
        :key="conv.Id"
        class="p-4 rounded-lg shadow transition cursor-pointer"
        :class="getCardClass(conv)"
      >
        <div class="text-sm text-gray-600">
          {{ formatTimestamp(conv.Ts) }}, {{ conv.Turns }} tours, {{ formatPrice(conv.TotalPrice) }}€
        </div>

        <!-- 🔖 Affichage de plusieurs labels -->
        <div class="flex flex-wrap items-center gap-2 mt-2">
          <div
            v-for="(pair, index) in getLabelPairs(conv)"
            :key="index"
            :class="['inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold', pair.color]"
          >
            <span>{{ pair.mainLabel }}</span>
            <span v-if="pair.subLabel" class="ml-1 text-[11px] font-normal opacity-80">
              • {{ pair.subLabel }}
            </span>
          </div>

          <!-- ⚠ Sensibilité -->
          <span
            v-if="conv.Meta?.sensitivity_level && conv.Meta.sensitivity_level !== 'normal'"
            class="ml-2 px-2 py-1 rounded-full text-xs font-bold uppercase"
            :class="getSensitivityClass(conv.Meta.sensitivity_level)"
          >
            ⚠ {{ conv.Meta.sensitivity_level }}
          </span>
        </div>
      </li>
    </ul>



    <p v-if="error" class="mt-4 text-red-600 font-medium">{{ error }}</p>
    <router-view />
  </div>
</template>

<script>
import { LABELS } from "@/assets/labels.js";
export default {
  data() {
    return {
      convsInfos: [],
      loading: true,
      error: null,
      lang: "fr" // ou "en"
    }
  },
  methods: {
    formatPrice(value) {
      if (typeof value !== 'number') return value;
      return parseFloat(value.toFixed(4)).toString();
    },    
    formatSafety(value) {
      if (Array.isArray(value) && value.length > 0) {
        return "⚠️";
      }
      return "";
    },
    // Format du timestamp pour l'affichage
    formatTimestamp(ts) {
      const date = new Date(ts * 1000);  // Convertir le timestamp en millisecondes
      return date.toLocaleString();         // Retourner la date au format lisible
    },
    getLabelPairs(conv) {
      const labelCodes = (conv.Meta?.label_code || "").split("|").filter(Boolean);
      const subCodes = (conv.Meta?.sub_label_code || "").split("|").filter(Boolean);

      const pairs = [];
      for (let i = 0; i < labelCodes.length; i++) {
        const subCode = subCodes[i];
        const mainCode = subCode === 'ACT_SENS' ? 'SEN' : labelCodes[i];
        const main = LABELS[mainCode];
        const sub = main?.sub?.[subCode];
        pairs.push({
          mainLabel: main ? main[this.lang] : mainCode,
          subLabel: sub ? sub[this.lang] : subCode,
          color: main?.color || "bg-gray-100 text-gray-700"
        });
      }
      return pairs;
    },
    getCardClass(conv) {
      const sens = conv.Meta?.sensitivity_level;
      if (sens === "critical") return "bg-red-50 border border-red-200";
      if (sens === "sensitive") return "bg-orange-50 border border-orange-200";
      return "bg-white hover:bg-blue-50";
    },
    getSensitivityClass(level) {
      switch (level) {
        case "critical":
          return "bg-red-600 text-white";
        case "sensitive":
          return "bg-orange-400 text-white";
        default:
          return "bg-gray-200 text-gray-800";
      }
    }
  },
  async mounted() {
    try {
      const res = await fetch(`${process.env.VUE_APP_AZURE_FUNCTION_URL}/api/convsInfos?code=${process.env.VUE_APP_AZURE_FUNCTION_CODE}&deviceId=${this.$route.params.deviceId}`, {headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }});
      if (!res.ok) throw new Error('Erreur lors du chargement')
      const data = await res.json()
      this.convsInfos = data
    } catch (err) {
      this.error = err.message || 'Erreur inconnue'
    } finally {
      this.loading = false
    }
  }
}
</script>
